if (!customElements.get('mytea-faq')) {
  customElements.define('mytea-faq', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.activeTopic = 'all';
      this.search = this.querySelector('[data-faq-search]');
      this.filters = [...this.querySelectorAll('[data-faq-filter]')];
      this.groups = [...this.querySelectorAll('[data-faq-group]')];
      this.empty = this.querySelector('[data-faq-empty]');

      this.search?.addEventListener('input', () => this.update(), options);
      this.filters.forEach((button) => button.addEventListener('click', () => {
        this.activeTopic = button.dataset.faqFilter;
        this.update();
      }, options));
      this.update();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    update() {
      const query = (this.search?.value || '').trim().toLocaleLowerCase();
      let visibleCount = 0;
      this.filters.forEach((button) => {
        const active = button.dataset.faqFilter === this.activeTopic;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      this.groups.forEach((group) => {
        let groupCount = 0;
        const topicMatches = this.activeTopic === 'all' || group.dataset.faqGroup === this.activeTopic;

        group.querySelectorAll('[data-faq-item]').forEach((item) => {
          const searchMatches = !query || (item.dataset.searchText || '').toLocaleLowerCase().includes(query);
          item.hidden = !(topicMatches && searchMatches);
          item.open = !item.hidden && visibleCount + groupCount === 0;
          if (!item.hidden) groupCount += 1;
        });

        group.hidden = groupCount === 0;
        visibleCount += groupCount;
      });

      if (this.empty) this.empty.hidden = visibleCount !== 0;
    }
  });
}
